export function isMobile(mobile: string | null | undefined): boolean {
  if (mobile === null || mobile === undefined) return false;
  const re = /^04[0-9]{8}$/g;
  return re.test(String(mobile));
}
